// src/routes/Routes.js
import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import AboutPage from "../pages/AboutUs";
import ContactUs from "../pages/ContactUs";
import JoinUs from "../pages/JoinUs";
import Scroll from "../components/Scroll";
import ServicesPage from "../pages/ServicePage"
import NotFound from "../pages/notfound";
import PrivacyPolicyPage from "../pages/privacyPolicy";
import JDPage from "../components/jobOpenenings/jonDescription";
import Partner from "../pages/Partners";
import TermsOfUsePage from "../pages/TermOfUse"
const ApplicationForm = React.lazy(() => import('../components/jobOpenenings/application'));
const AppRoutes = () => {
  return (
    <>
    <Scroll/>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/joinus" element={<JoinUs />} />
      <Route path="/service/:serviceId" element={<ServicesPage />} />
      <Route path="*" element={<NotFound />} />
      <Route path="/job/:id" element={<JDPage />} />
      <Route
          path="/application/:id"
          element={
            <Suspense fallback={<div>Loading application form...</div>}>
              <ApplicationForm />
            </Suspense>
          }
        />
     <Route path="/alliance" element={<Partner />} />
     <Route path="/privacy-policy" element={<PrivacyPolicyPage/>} />
     <Route path="/terms-of-use" element={<TermsOfUsePage/>} />
     
    </Routes>
    </>
  );
};

export default AppRoutes;